import React from 'react';
import { useSelector } from 'react-redux'
import FlipCard from './FlipCard'
import { selectMessages } from '../languages/languagesSlice'
import {
  GAME_STATUS,
  selectGameStatus,
  selectLatestPairedCard
} from './gameSlice'
import './Board.css'

const Board = ({ imgLevelItems, cards, lang, onRestart, onRandomStart }) => {
  const gameStatus = useSelector(selectGameStatus)
  const latestPairedCard = useSelector(selectLatestPairedCard)
  const messages = useSelector(selectMessages)

  const renderedCards = cards.map((card,i) => {
    if (card.pairType === 'img') {
      return <FlipCard
        key={i}
        src={imgLevelItems}
        card={card}
        lang={lang}
      />
    } else if (card.pairType === 'word') {
      return <FlipCard key={i} card={card} lang={lang} />
    }
  })

  let renderedGameInfo = ''
  if (gameStatus === GAME_STATUS.GAMEOVER) {
    renderedGameInfo = <span className="color-red">{messages.congratulation}</span>
  } else if (latestPairedCard !== null) {
    renderedGameInfo = <span><span className="color-red">{latestPairedCard[lang]}</span> {messages.matched}</span>
  }

  const renderedLevelControlPanel = gameStatus === GAME_STATUS.GAMEOVER ? (
    <div className="level-control-panel">
      <button className="btn btn-lg" onClick={onRestart}>{messages.again}</button>
      <button className="btn btn-lg" onClick={onRandomStart}>{messages.next}</button>
    </div>
  ) : ''

  return (
    <div className="board">
      <div className="game">
        <div className="flip-cards">{renderedCards}</div>
        {latestPairedCard !== null ? <div className="game-info">{renderedGameInfo}</div> : ''}
        {renderedLevelControlPanel}
      </div>
    </div>
  )
}

export default Board